import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, SettingsIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-gradient-to-b from-zinc-950 via-emerald-950/10 to-zinc-950 py-16 sm:py-24" data-id="element-176">
      <div className="max-w-4xl mx-auto px-4" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-178">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-500/10 rounded-2xl mb-6" data-id="element-179">
            <ZapIcon className="w-8 h-8 text-emerald-400" data-id="element-180" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4" data-id="element-181">
            El{' '}
            <span className="text-emerald-400" data-id="element-182">
              "Método de Instalación a Prueba de Errores"
            </span>
          </h2>
        </motion.div>

        {/* Discovery statement */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 mb-10" data-id="element-183">
          <p className="text-lg text-zinc-300 leading-relaxed" data-id="element-184">
            Después de probar, documentar y actualizar el proceso completo de
            instalación de Magis TV en distintos dispositivos — desde celulares
            Android básicos hasta Smart TVs con Android TV, Fire TV Stick y más
            — identificamos algo clave:
          </p>
          <p className="text-xl sm:text-2xl text-white font-bold mt-6 text-center" data-id="element-185">
            El <span className="text-red-500" data-id="element-186">80% de las fallas</span> ocurren
            en exactamente <span className="text-emerald-400" data-id="element-187">3 puntos</span>{' '}
            del proceso.
          </p>
        </motion.div>

        {/* The 3 critical points */}
        <div className="space-y-4 mb-10" data-id="element-188">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex items-start gap-4 bg-zinc-900/30 border border-zinc-800 rounded-xl p-5" data-id="element-189">
            <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-190">
              <SettingsIcon className="w-5 h-5 text-amber-500" data-id="element-191" />
            </div>
            <div data-id="element-192">
              <div className="flex items-center gap-2 mb-1" data-id="element-193">
                <span className="text-amber-500 font-bold" data-id="element-194">1.</span>
                <h3 className="text-white font-bold" data-id="element-195">
                  Habilitar fuentes desconocidas
                </h3>
              </div>
              <p className="text-zinc-400 text-sm" data-id="element-196">
                Que en cada dispositivo está en un lugar diferente
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex items-start gap-4 bg-zinc-900/30 border border-zinc-800 rounded-xl p-5" data-id="element-197">
            <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-198">
              <DownloadIcon className="w-5 h-5 text-cyan-500" data-id="element-199" />
            </div>
            <div data-id="element-200">
              <div className="flex items-center gap-2 mb-1" data-id="element-201">
                <span className="text-cyan-500 font-bold" data-id="element-202">2.</span>
                <h3 className="text-white font-bold" data-id="element-203">
                  Descargar la versión correcta del APK
                </h3>
              </div>
              <p className="text-zinc-400 text-sm" data-id="element-204">
                No cualquier versión, sino la estable y actualizada
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex items-start gap-4 bg-zinc-900/30 border border-zinc-800 rounded-xl p-5" data-id="element-205">
            <div className="w-10 h-10 bg-emerald-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-206">
              <ShieldCheckIcon className="w-5 h-5 text-emerald-500" data-id="element-207" />
            </div>
            <div data-id="element-208">
              <div className="flex items-center gap-2 mb-1" data-id="element-209">
                <span className="text-emerald-500 font-bold" data-id="element-210">3.</span>
                <h3 className="text-white font-bold" data-id="element-211">
                  Configurar la app por primera vez
                </h3>
              </div>
              <p className="text-zinc-400 text-sm" data-id="element-212">
                Sin saber qué permisos aceptar y cuáles evitar
              </p>
            </div>
          </motion.div>
        </div>

        {/* Conclusion */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-r from-emerald-500/10 to-cyan-500/10 border border-emerald-500/20 rounded-2xl p-8 text-center" data-id="element-213">
          <p className="text-lg sm:text-xl text-white font-medium" data-id="element-214">
            Nuestra guía fue construida exactamente alrededor de esos 3 puntos
            críticos.
          </p>
          <p className="text-emerald-400 font-bold text-xl mt-4" data-id="element-215">
            No es una guía genérica. Es una guía construida desde los errores
            reales.
          </p>
        </motion.div>
      </div>
    </section>;
}